import { Services } from 'containers/Services'

export default Services
